import { useState } from 'react';
import { Box, TextField } from '@mui/material';
import { nodeConfigs } from '../../../components/react-flow/NodesSection';

function ReadBlocks({ selectedReadBlock, setSelectedReadBlock, pipelineName, setPipelineName }) {
  const readBlocks = nodeConfigs?.Read;

  return (
    <div>
      <TextField
        label="Pipeline Name"
        variant="outlined"
        size="small"
        // fullWidth
        width={500}
        value={pipelineName}
        onChange={(e) => setPipelineName(e.target.value)}
        sx={{ mb: 2 }}
      />

      <div>Select Read Block</div>
      <Box style={{ display: 'flex', flexWrap: 'wrap' }} gap={2} mt={1}>
        {readBlocks?.map((item, index) => (
          <Box
            key={index}
            onClick={() => setSelectedReadBlock(item)}
            sx={{
              background: selectedReadBlock.key === item.key ? '#B8E6FE' : '#fff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              width: '100px',
              height: '100px',
              border: selectedReadBlock.key === item.key ? '2px solid #21BCFF' : '1px dashed gray',
              borderRadius: '5px',
              wordBreak: 'break-word',
              boxSizing: 'border-box',
              padding: '5px',
              '&:hover': {
                background: selectedReadBlock.key === item.key ? '#B8E6FE' : '#f4f4f4',
                cursor: 'pointer',
              },
            }}
          >
            {item.label}
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default ReadBlocks;
